import CircleCollection from "./circleCollection";

export default class StandardCircles2 extends CircleCollection {
  constructor(position, options) {
    let circleDefs = [
      { radius: 250, text: "C3" },
      { radius: 500, text: "C4" }
    ];
    super(position, circleDefs, options);
  }
}
